(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('profileSearchModal', ['$scope', '$filter', 'NgTableParams', '$stateParams', 'profilesService', '$uibModalInstance', 'profileSchema', 'buttonInfo', 'profileHelper', "audiencesService", "growlService",
            function ($scope, $filter, ngTableParams, $stateParams, profilesService, $uibModalInstance, profileSchema, buttonInfo, profileHelper, audiencesService, growlService) {

                $scope.profileSchema = profileSchema;
                $scope.sorting = { _createdOn: "asc" };

                $scope.buttonInfo = buttonInfo;

                $scope.clearSearch = function () {
                    $scope.properties = [{
                        selector: "",
                        logic: "=~^",
                        value: ""
                    }];
                }

                // initialise properties ...
                $scope.clearSearch();

                $scope.audience = {}

            $scope.queryForm = {}

                $scope.profilesData = [];

                //Sorting
                $scope.tableSorting = new ngTableParams({
                    page: 1,            // show first page
                    count: 10,           // count per page
                    sorting: $scope.sorting
                }, {
                        total: $scope.profilesData.length, // length of data
                        getData: function ($defer, params) {
                            // use build-in angular filter
                            var orderedData = params.sorting() ? $filter('orderBy')($scope.profilesData, params.orderBy()) : $scope.profilesData;
                            $scope.sorting = params.sorting();
                            $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                            params.total(orderedData.length);
                        }
                    });


                $scope.getProfiles = function (criteria) {

                    if (criteria) {
                        $scope.properties = profileHelper.getCriteria(criteria);
                        return profilesService.getProfilesWithQueries($stateParams.pickedApiSpaceId, criteria)
                            .then(function (response) {
                                $scope.profilesData = response;
                                $scope.profilesCount = response.length;
                                return true;
                            }).catch(function (err) {
                                return false;
                            });
                    }
                    else {
                        return profilesService.getProfiles($stateParams.pickedApiSpaceId)
                            .then(function (response) {
                                $scope.profilesData = response;
                                $scope.profilesCount = response.length;
                                return true;
                            }).catch(function (err) {
                                return false;
                            });
                    }
                };

                $scope.doSearch = function () {

                    var criteria = profileHelper.getExtension($scope.properties);

                    $scope.getProfiles(criteria)
                        .then(function (succeeded) {
                            $scope.tableSorting.reload();
                        });
                };

                $scope.saveAudience = function () {
                    var criteria = profileHelper.getExtension($scope.properties);

                    var data = {
                        name: $scope.audience.name,
                        description: $scope.audience.description,
                        query: criteria,
                        isTest: buttonInfo.isTest
                    };

                    audiencesService.createAudience($stateParams.pickedApiSpaceId, data)
                        .then(function (audience) {
                            growlService.success('Audience successfuly saved.');
                            $uibModalInstance.close(audience);
                        }).catch(function (error) {
                            growlService.danger("Audience wasn't created due to: " + error.statusText);
                        });
                }

                $scope.ok = function (profile) {
                    $uibModalInstance.close(profile);
                };

                $scope.close = function (profileId) {
                    $uibModalInstance.dismiss();
                };


            }]);

})(window.angular);
